import React from 'react';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <p className="hero-text">
          This is the place where you can create books using AI and readers can choose interesting books to read. Explore your Creativity
        </p>
      </div>
    </section>
  );
};

export default HeroSection;






